module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "MetaPool_logo.49c6f9c0.png";